import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import PageMeta from '@/components/base/PageMeta';
import FadeIn from '@/components/base/FadeIn';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoryPreview from './components/CategoryPreview';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const schemaJson = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '蓝色小导航',
        url: 'https://bluenav.cn',
        slogan: '精致轻量的蓝色小导航解决方案',
        email: 'hello@bluenav.cn',
        foundingDate: '2024',
        address: { '@type': 'PostalAddress', addressCountry: 'CN' },
      },
      {
        '@type': 'WebSite',
        name: '蓝色小导航',
        url: 'https://bluenav.cn',
        description: '蓝色小导航是一款简洁高效的轻量级导航组件，提供清晰的蓝色视觉风格与灵活的布局方案。',
        inLanguage: 'zh-CN',
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          { '@type': 'Question', name: '蓝色小导航是否免费使用？', acceptedAnswer: { '@type': 'Answer', text: '是的，蓝色小导航完全开源免费，采用 MIT 许可证。无论您是个人开发者还是企业用户，都可以自由使用、修改和分发。' } },
          { '@type': 'Question', name: '蓝色小导航支持哪些浏览器？', acceptedAnswer: { '@type': 'Answer', text: '蓝色小导航支持所有现代浏览器，包括 Chrome 90+、Firefox 88+、Safari 14+ 和 Edge 90+。兼容覆盖率达到 99.8%。' } },
          { '@type': 'Question', name: '如何将蓝色小导航集成到 React 项目中？', acceptedAnswer: { '@type': 'Answer', text: '蓝色小导航提供了 React 封装组件，可通过 npm 安装。同时也支持直接在项目中使用原生版本，不受框架限制。' } },
          { '@type': 'Question', name: '蓝色小导航的动画效果会影响性能吗？', acceptedAnswer: { '@type': 'Answer', text: '不会。所有动画均使用 GPU 加速的 CSS 属性（transform 和 opacity），在主流设备上均能保持 60fps 的流畅帧率。' } },
          { '@type': 'Question', name: '可以自定义导航栏的颜色吗？', acceptedAnswer: { '@type': 'Answer', text: '完全可以。蓝色小导航提供了完善的 CSS 变量系统和 JavaScript API，支持自定义所有颜色属性。还内置了 8 套预设主题供快速选择。' } },
        ],
      },
    ],
  };

  return (
    <>
      <PageMeta
        title="首页"
        description="蓝色小导航是一款简洁高效的轻量级导航组件，提供灵活的布局方案与优雅的蓝色视觉风格。快速集成、轻松定制，让页面结构更清晰、用户体验更流畅。"
        keywords="蓝色小导航,蓝色小导航组件,小导航栏设计,蓝色导航菜单,轻量级导航UI"
        canonicalUrl="https://bluenav.cn"
        schemaJson={schemaJson}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FadeIn><FeaturesSection /></FadeIn>
        <FadeIn delay={100}><CategoryPreview /></FadeIn>
        <FadeIn delay={100}><LatestArticles /></FadeIn>
        <FadeIn delay={100}><FAQSection /></FadeIn>
        <FadeIn delay={100}><CTASection /></FadeIn>
      </main>
      <Footer />
    </>
  );
}